import { Link } from "react-router-dom";
import { getTopRanked } from "@/mocks/comics";
import SectionHeading from "@/components/base/SectionHeading";

export default function RankingSection() {
  const top = getTopRanked();

  return (
    <section className="relative overflow-hidden bg-foreground-950 py-16 md:py-20">
      <div
        className="pointer-events-none absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 30%, oklch(var(--primary-500) / 0.5), transparent 45%), radial-gradient(circle at 80% 70%, oklch(var(--accent-500) / 0.4), transparent 45%)",
        }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="人气榜单"
            title="本周热度 TOP 3"
            desc="根据读者人气与近期热度综合排序，上榜作品口碑与热度兼具，值得优先追读。"
          />
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-accent-400 transition-colors hover:text-accent-300"
          >
            查看完整榜单
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-3">
          {top.map((comic) => (
            <div
              key={comic.id}
              className="flex items-center gap-4 rounded-lg border border-background-100/10 bg-background-50/5 p-4 backdrop-blur transition-colors hover:bg-background-50/10"
            >
              <span className="font-heading text-4xl font-black text-accent-500">{comic.rank}</span>
              <div className="min-w-0 flex-1">
                <h3 className="truncate font-heading text-lg font-bold text-background-50">{comic.title}</h3>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-background-300">{comic.summary}</p>
                <div className="mt-2 flex items-center gap-2 text-xs text-background-400">
                  <span className="rounded-full bg-accent-500/20 px-2 py-0.5 text-accent-300">{comic.status}</span>
                  <span>{comic.views}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}